// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-parameters
export const parseJson = <T = any>(
  value: string | undefined | null
): T | undefined => {
  try {
    return value ? (JSON.parse(value) as T) : undefined;
  } catch {
    return undefined;
  }
};

export function stringToHash(input: string, max = 10): number {
  let hash = 0;

  if (input.length === 0) {
    return hash;
  }

  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    hash = (hash << 5) - hash + c;
    hash = hash & hash;
  }

  return Math.abs(hash) % max;
}

export function decodePageIndex(pageToken: string | undefined): number {
  return +atob(pageToken || '').split('|')[1] || 0;
}

// The token ends up in SWR keys, so it must be deterministic: a random part would change the key on
// every render and refetch in a loop. The gateway only reads the index after the `|`.
export function encodePageToken(pageIndex: number): string {
  return btoa(`page|${pageIndex}`);
}

// Returns the plural form of `word`, unless `count` is exactly 1 (then the word
// is returned as-is). Any other count — including 0 — is pluralized, matching
// English usage ("0 rules", "1 rule", "2 rules").
export function pluralize(word: string, count?: number): string {
  if (count === 1) {
    return word;
  }
  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }
  if (/(s|x|z|ch|sh)$/i.test(word)) {
    return `${word}es`;
  }
  return `${word}s`;
}

export type Stringifyable =
  | string
  | number
  | boolean
  | null
  | undefined
  | Stringifyable[]
  | { [key: string]: Stringifyable };
